"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const WhyChooseSmile4Me: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Why Choose Smile4Me Dental Care?
        </h2>
        <div className="my-8 mx-auto max-w-2xl rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/photo-suited-man-standing-beside-smile4me-office-sign.webp"
            alt="photo-suited-man-standing-beside-smile4me-office-sign"
            width={800}
            height={600}
            className="w-full h-auto block"
            sizes="(max-width: 768px) 100vw, 672px"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          <Link
            href="https://www.opencare.com/dentists/queens-ny/dr-iosif-khaimov-24631320788d/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Dr. Iosif Khaimov
          </Link>{" "}
          founded Smile4Me to bring personalized, technology-driven dentistry
          to the Astoria community. His NYU College of Dentistry training,
          combined with over seven years of experience across multiple NYC
          dental practices and ongoing continuing education, means patients
          receive care that reflects the latest advancements in dental
          technique and technology.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          What sets Smile4Me apart for tooth extractions in Astoria:
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          An Experienced and Caring Team
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Our team uses modern techniques, advanced technology, and genuine
          compassion at every appointment. Sedation options are available for
          patients who feel nervous or anxious.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Flexible and Accessible Financing
        </h3>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Competitive rates:</strong> Available for both simple and
            surgical extractions.
          </li>
          <li>
            <strong>No-interest financing:</strong> Spread costs over 2 years,
            subject to credit approval.
          </li>
          <li>
            <strong>Insurance billing:</strong> Direct billing to most major
            providers.
          </li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Same-Day Emergency Appointments
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          If you&apos;re in pain, waiting is not an option. Walk-ins are
          welcome, and we do everything possible to accommodate urgent cases
          the same day.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Post-Extraction Tooth Replacement Options
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          After an extraction, we offer dental implants, bridges, and dentures
          to restore your smile. Our team will recommend the best solution
          based on your needs and budget.
        </p>
      </div>
    </section>
  );
};

export default WhyChooseSmile4Me;
